import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
    palette: {
        secondary: {
            light: '#f6685e',
            main: '#f44336',
            dark: '#aa2e25'
        },
        primary: {
            light: '#637bfe',
            main: '#2196f3',
            dark: '#2a3eb1'
        },
    },
})

export default theme